module.exports = __webpack_public_path__ + "img/dashboard.d55558ae.svg";